import PropTypes from "prop-types";
import { system_dropdown } from "../../service/system";

import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";

export default function FormDropdown(props) {
  const {
    className = "",
    isControl = true,
    setting: { Controller, control, trigger, isSubmitted, isEdit = true } = {},
    data: {
      name,
      elValue,
      elChange,
      options = [],
      optionLabel = "label",
      optionValue = "value",
      placeholder = "",
      filter = false,
      filterBy = "value",
      disabled = false,
      showClear = true,
      changeFun = () => null,
    },
  } = props;

  const onChange = (e, field) => {
    let value = e.value === undefined ? null : e.value;

    if (isControl) {
      field.onChange(value);

      if (isSubmitted) {
        trigger();
      } else {
        trigger(name);
      }
    } else {
      elChange({ name, value, options: props.data });
    }

    changeFun();
  };

  const renderElement = ({ field, fieldState } = {}) => {
    let value = isControl ? field.value : elValue;

    return (
      <div className={classNames("flex align-items-center", className)}>
        <Dropdown
          id={name}
          className={classNames(
            { "p-invalid": isControl && fieldState.invalid },
            "w-full",
            className
          )}
          name={name}
          value={value ?? null}
          onChange={(e) => onChange(e, field)}
          disabled={!isEdit || disabled}
          placeholder={placeholder}
          options={options}
          optionLabel={optionLabel}
          optionValue={optionValue}
          filter={filter}
          filterBy={filterBy}
          emptyFilterMessage={system_dropdown.emptyFilter}
          emptyMessage={system_dropdown.empty}
          showClear={showClear}
        />
      </div>
    );
  };

  return (
    <>
      {isControl ? (
        <Controller
          name={name}
          control={control}
          render={({ field, fieldState }) =>
            renderElement({ field, fieldState })
          }
        />
      ) : (
        renderElement()
      )}

    </>
  );
}

FormDropdown.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    changeFun: PropTypes.func,
    disabled: PropTypes.bool,
    elChange: PropTypes.func,
    elValue: PropTypes.any,
    filter: PropTypes.bool,
    filterBy: PropTypes.string,
    name: PropTypes.string,
    optionLabel: PropTypes.string,
    optionValue: PropTypes.string,
    options: PropTypes.array,
    placeholder: PropTypes.string,
    showClear: PropTypes.bool,
  }).isRequired,
  isControl: PropTypes.bool,
  setting: PropTypes.shape({
    control: PropTypes.object,
    Controller: PropTypes.elementType,
    isEdit: PropTypes.bool,
    isSubmitted: PropTypes.bool,
    trigger: PropTypes.func,
  }),
};
